import { Flex, Spinner } from '@chakra-ui/react';
import { HelivanColor } from './helivan/HelivanColor';

export const HelivanLoading = () => {
  return (
    <Flex
      width="full"
      height="full"
      alignItems="center"
      justifyContent="center"
      bg={HelivanColor.background.primary}
      border="1px solid"
      borderColor={HelivanColor.border.primary}
      borderRadius="8px"
    >
      <Spinner />
    </Flex>
  );
};
